import { memo } from 'react';
import { css, cx } from '@linaria/atomic';
import { motion } from 'motion/react';
import { Icon, IconName } from '@frontend/icons';
import { NakedButton } from '../../../../naked/naked-button.component';
import { Text } from '../../../text/text.component';
import { useRadioContext } from '../../providers/radio-provider';
import { RadioStyles } from '../radio/radio.styles';
import { RadioCardStyles } from './radio-card.styles';

const componentDivStyle1 = css`
  &:empty {
    display: none;
  }
`;

type Props = {
  title: React.ReactNode;
  description?: React.ReactNode;
  selectionContent?: React.ReactNode;
  value: string;
  trackingId?: string;
  className?: string;
  iconName?: IconName;
  isInteractive?: boolean;
};
const MotionNakedButton = motion.create(NakedButton);
export const RadioCardOption = memo(
  ({ title, description, selectionContent, trackingId, value, className, iconName, isInteractive }: Props) => {
    const { getOptionProps, animate } = useRadioContext();
    const { active, checked, onChange, ...optProps } = getOptionProps(value);
    const radioStyles = RadioStyles.radio({ active, checked, disabled: optProps.disabled });
    const radioOptionStyles = RadioCardStyles.radioCard;
    const radioOptionContentContainerStyles = RadioCardStyles.radioCardContentContainer;
    const radioOptionContentStyles = RadioCardStyles.radioCardContent;
    const radioCheckboxStyles = RadioCardStyles.radioCheckbox;
    const radioIconStyles = RadioCardStyles.radioIcon;
    const radioDescriptionStyles = RadioCardStyles.radioDescription;

    const WrapperButton = animate ? MotionNakedButton : NakedButton;
    const animProps = animate ? { layout: true, transition: { layout: { duration: 0.3, ease: 'easeOut' } } } : {};

    return (
      <WrapperButton
        {...animProps}
        {...optProps}
        className={cx(radioOptionStyles, optProps.className, className)}
        onClick={onChange}
        type='button'
        trackingId={trackingId}
      >
        <div className={cx(radioStyles, radioCheckboxStyles)} />
        <div className={radioOptionContentContainerStyles(isInteractive && !optProps.disabled)}>
          <div className={radioOptionContentStyles(isInteractive && !optProps.disabled)}>
            <Text as='span' size='medium' weight='bold'>
              {title}
            </Text>
            {description && (
              <Text as='span' size='small' color='subdued' className={radioDescriptionStyles}>
                {description}
              </Text>
            )}
            {/* NOTE: this will block radio option events from triggering while user interacting with input */}
            <div
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              className={componentDivStyle1}
            >
              {checked && selectionContent}
            </div>
          </div>
          {iconName && <Icon name={iconName} className={cx('button-icon', radioIconStyles)} color='default' />}
        </div>
      </WrapperButton>
    );
  }
);
RadioCardOption.displayName = 'RadioCardOption';
